import React from 'react';
import './InspirationContent.css';
import { Link } from 'react-router-dom';

const blinds = [
    { title: 'Roman Blinds', desc: 'Versatile and Contemporary Blinds', img: '/Assets/InspirationImages/01.webp', link: '/products/roman-blinds' },
    { title: 'Colby Blinds', desc: 'Most Energy Efficient Blinds', img: '/Assets/InspirationImages/02.webp', link: '/products/colby-blinds' },
    { title: 'Patricia Blinds', desc: 'Luxurious looking Blinds', img: '/Assets/InspirationImages/03.webp', link: '/products/patricia-blinds' },
    { title: 'Sierra Blinds', desc: 'Enjoy privacy and an open view at the same time', img: '/Assets/InspirationImages/04.webp', link: '/products/sierra-blinds' },
    { title: 'Grayson Blinds', desc: 'A combination of Roller and Venetian Blinds', img: '/Assets/InspirationImages/05.webp', link: '/products/grayson-blinds' },
    { title: "Luzon Blinds", desc: 'Creating an interesting look for your interior', img: '/Assets/InspirationImages/06.webp', link: '/products/luzon-blinds' },
    { title: 'Meliso Blinds', desc: 'Perfect fusion of Roman and Roller Blinds', img: '/Assets/InspirationImages/07.webp', link: '/products/meliso-blinds' },
    { title: 'Roller Blinds', desc: 'A pinnacle of elegance in window coverings', img: '/Assets/InspirationImages/08.webp', link: '/products/roller-blinds' },
    { title: 'Wooden Blinds', desc: 'Timeless window fashion', img: '/Assets/InspirationImages/09.webp', link: '/products/wooden-venetian-blinds' },
    { title: 'Skylight Blinds', desc: 'A combination of modern design and classic colour range', img: '/Assets/InspirationImages/10.webp', link: '/products/skylight-blinds' },
];

const InspirationContent = () => {
    const paired = [];
    for (let i = 0; i < blinds.length; i += 2) {
        paired.push(blinds.slice(i, i + 2));
    }

    return (
        <section className="Inspiration-Page-Content">
            <div className="Insp-blinds-section">
                <div className="Insp-blinds-wrapper">
                    {paired.map((pair, index) => {
                        const rowClass = `Insp-row-${(index % 5) + 1}`;
                        return (
                            <div className={`Insp-blinds-row ${rowClass}`} key={index}>
                                {pair.map((item, subIndex) => (
                                    <Link to={item.link} className={`Insp-blinds-card Insp-card-${subIndex + 1}`} key={subIndex}>
                                        <div className="Insp-blinds-image-wrapper">
                                            <img src={item.img} alt={item.title} className="blinds-image" />
                                        </div>
                                        <div className="Insp-blinds-text">
                                            <div className="Insp-blinds-label">{item.title}</div>
                                            <div className="Insp-blinds-subtext">{item.desc}</div>
                                        </div>
                                    </Link>
                                ))}
                            </div>
                        );
                    })}
                </div>
                 <div className="Filter-Inspiration-CTA">
                    <Link to="/filter-inspiration">Discover More Options</Link>
                </div>
            </div>
        </section>
    );
};

export default InspirationContent;
